// OPTION 1 PDP GROUPED SWATCHES

function initSwatchLabel() {
  // Target the container of all swatches
  var $swatchContainer = $('.option-selector__btns-1');
  // Get all swatches (each input + label pair is one swatch)
  var $allInputs = $swatchContainer.find('input.opt-btn');
  var $allLabels = $swatchContainer.find('label.opt-label');
  
  // If we have more than 17 swatches, implement the toggle feature
  if ($allInputs.length > 17) {
    // Hide swatches beyond the 17th one
    $allInputs.slice(17).hide();
    $allLabels.slice(17).hide();
    
    // Calculate the number of hidden swatches
    var hiddenCount = $allInputs.length - 17;
    
    // Create the "10+" button (or with actual count of hidden swatches)
    var toggleButtonHtml = `
      <input class="opt-btn js-option swatch-toggle" type="radio" id="swatch-toggle-btn" value="Show More">
      <label class="opt-label swatch-toggle-label" data-swatch="toggle" style="display: flex; justify-content: center; align-items: center;" for="swatch-toggle-btn">
        <span class="opt-label__texte" style="color: #333; text-align: center;">${hiddenCount}+</span>
      </label>
    `;
    
    // Append the toggle button after the 17th swatch
    $($allLabels[16]).after(toggleButtonHtml);
    
    // Style the toggle button to look like other swatches
    $('.swatch-toggle, .swatch-toggle-label').css({
      'cursor': 'pointer',
      'background': '#fff'
    });
    
    // Add click handler for the toggle button
    $(document).on('click', '#swatch-toggle-btn, .swatch-toggle-label', function(e) {
      e.preventDefault();
      
      // Show all hidden swatches
      $allInputs.slice(17).show();
      $allLabels.slice(17).show();
      
      // Hide the toggle button
      $('.swatch-toggle, .swatch-toggle-label').hide();
    });
  }
}

$(document).ready(function() {
  initSwatchLabel();
});

document.addEventListener('variant-changed', (e) => {
  initSwatchLabel();
});


// RUN MOBILE ONLY
// $(document).ready(function() {
//   // Only run the swatch toggle functionality for screen sizes smaller than 768px
//   if (window.innerWidth < 768) {
//     // Target the container of all swatches
//     var $swatchContainer = $('.option-selector__btns-1');
//     // Get all swatches (each input + label pair is one swatch)
//     var $allInputs = $swatchContainer.find('input.opt-btn');
//     var $allLabels = $swatchContainer.find('label.opt-label');
    
//     // If we have more than 17 swatches, implement the toggle feature
//     if ($allInputs.length > 17) {
//       // Hide swatches beyond the 17th one
//       $allInputs.slice(17).hide();
//       $allLabels.slice(17).hide();
      
//       // Calculate the number of hidden swatches
//       var hiddenCount = $allInputs.length - 17;
      
//       // Create the "10+" button (or with actual count of hidden swatches)
//       var toggleButtonHtml = `
//         <input class="opt-btn js-option swatch-toggle" type="radio" id="swatch-toggle-btn" value="Show More">
//         <label class="opt-label swatch-toggle-label" data-swatch="toggle" style="display: flex; justify-content: center; align-items: center;" for="swatch-toggle-btn">
//           <span class="opt-label__texte" style="color: #333; text-align: center;">${hiddenCount}+</span>
//         </label>
//       `;
      
//       // Append the toggle button after the 17th swatch
//       $($allLabels[16]).after(toggleButtonHtml);
      
//       // Style the toggle button to look like other swatches
//       $('.swatch-toggle, .swatch-toggle-label').css({
//         'cursor': 'pointer',
//         'background': '#fff'
//       });
      
//       // Add click handler for the toggle button
//       $(document).on('click', '#swatch-toggle-btn, .swatch-toggle-label', function(e) {
//         e.preventDefault();
        
//         // Show all hidden swatches
//         $allInputs.slice(17).show();
//         $allLabels.slice(17).show();
        
//         // Hide the toggle button
//         $('.swatch-toggle, .swatch-toggle-label').hide();
//       });
//     }
//   }
// });






// OLD CODE

// OPTION 1 PDP NON-GROUPED SWATCHES
// $(document).ready(function() {
//   // Target the container of all swatches
//   var $swatchContainer = $('.option-selector__btns');
//   // Get all swatches (each input + label pair is one swatch)
//   var $allInputs = $swatchContainer.find('input.opt-btn');
//   var $allLabels = $swatchContainer.find('label.opt-label');
  
//   // If we have more than 17 swatches, implement the toggle feature
//   if ($allInputs.length > 17) {
//     // Hide swatches beyond the 17th one
//     $allInputs.slice(17).hide();
//     $allLabels.slice(17).hide();
    
//     // Calculate the number of hidden swatches
//     var hiddenCount = $allInputs.length - 17;
    
//     // Create the "10+" button (or with actual count of hidden swatches)
//     var toggleButtonHtml = `
//       <input class="opt-btn js-option swatch-toggle" type="radio" id="swatch-toggle-btn" value="Show More">
//       <label class="opt-label swatch-toggle-label" data-swatch="toggle" style="display: flex; justify-content: center; align-items: center;" for="swatch-toggle-btn">
//         <span class="opt-label__texte" style="color: #333; text-align: center;">${hiddenCount}+</span>
//       </label>
//     `;
    
//     // Append the toggle button after the 17th swatch
//     $($allLabels[16]).after(toggleButtonHtml);
    
//     // Style the toggle button to look like other swatches
//     $('.swatch-toggle, .swatch-toggle-label').css({
//       'cursor': 'pointer',
//       'background': '#fff'
//     });
    
//     // Add click handler for the toggle button
//     $(document).on('click', '#swatch-toggle-btn, .swatch-toggle-label', function(e) {
//       e.preventDefault();
      
//       // Show all hidden swatches
//       $allInputs.slice(17).show();
//       $allLabels.slice(17).show();
      
//       // Hide the toggle button
//       $('.swatch-toggle, .swatch-toggle-label').hide();
//     });
//   }
// });


// OPTION 2
// // Select the container
// const container = document.querySelector('.option-selector__btns');

// // Style the container to show only part of the swatches
// container.style.height = '100px';
// container.style.overflow = 'hidden';
// container.style.position = 'relative';

// // Add gradient overlay at the bottom
// const gradient = document.createElement('div');
// gradient.style.position = 'absolute';
// gradient.style.bottom = '0';
// gradient.style.left = '0';
// gradient.style.width = '100%';
// gradient.style.height = '30px';
// gradient.style.background = 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))';
// container.appendChild(gradient);

// // Create and add the "show" button
// const showButton = document.createElement('div');
// showButton.textContent = 'Show more';
// showButton.style.textAlign = 'center';
// showButton.style.cursor = 'pointer';
// showButton.style.marginTop = '5px';
// showButton.style.color = '#333';
// showButton.style.fontWeight = 'normal';

// // Insert the button after the container
// container.parentNode.insertBefore(showButton, container.nextSibling);

// // Add click event to expand the container
// showButton.addEventListener('click', function() {
//   container.style.height = 'auto';
//   gradient.style.display = 'none';
//   showButton.style.display = 'none';
// });